/* global analytics */

import React, { Component } from 'react';
import Table from '../components/Table';
import helper from '../services/helper';

export default class Transactions extends Component {

    onCellInput(value) {
        this.props.onCellInput(value);
    }

    componentWillMount() {
        if(process.env.NODE_ENV === 'production') analytics.page(helper.getCurrentPageName());
        window.Intercom("update");
    }

    render() {
        return (
            <main>
                <Table onCellInput={this.onCellInput.bind(this)} path={this.props.match.path} data={this.props.data} />
            </main>
        );
    }
}


// WEBPACK FOOTER //
// ./src/views/Transactions.js